import * as React from 'react';

import { Alert, Button, Container, Stack } from '@mui/material';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import BpmnTable from './BpmnTable';
import { useNavigate } from "react-router-dom";



import Service from '../../../util/Service';

import '../../../App.css';

export default function BpmnManagerPanel() {
  const navigate = useNavigate();
  const [wait, setWait] = React.useState(false);
  const [msg, setMsg] = React.useState();
  const handleImport = () => {
    const file = document.getElementById("file");
    file.click();
  }

  const upload = () => {
    let file = document.getElementById("file");
    let dados = new FormData();
    setWait(true);
    dados.append('file', file.files[0]);
    Service.UPLOAD("/api/bpmn/import", dados).then((result) => {
      setWait(false);
      window.location.reload(false);
    }).catch((e) => {
      setWait(false);
      setMsg({ tipo: 'error', mensagem: e.message });
    });
  }

  return (
    <React.Fragment>

      <Stack spacing={2}>

        <div className='to-right-div' >
          <Button variant="outlined" onClick={handleImport}>
            Importar Integração
          </Button>
          <Button variant="outlined" onClick={ () => navigate('/novaIntegracao') }>Nova Integração</Button>
        </div>
        <BpmnTable />

        {msg && <Alert severity={msg.tipo} variant="outlined">{
          msg.mensagem
        }</Alert>}

      </Stack>
      <Backdrop
        sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
        open={wait}
        onClick={() => setWait(false)}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <input type="file" id="file" style={{ display: 'none' }} onChange={upload} accept="application/zip" />
    </React.Fragment>
  );
}